/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LinkPreviewItem
 */
export interface LinkPreviewItem {
    /**
     * 
     * @type {number}
     * @memberof LinkPreviewItem
     */
    rowIndex?: number;
    /**
     * 
     * @type {string}
     * @memberof LinkPreviewItem
     */
    joinKeyValue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LinkPreviewItem
     */
    matchedEntityId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LinkPreviewItem
     */
    matchedEntityName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof LinkPreviewItem
     */
    isLinked?: boolean;
}

/**
 * Check if a given object implements the LinkPreviewItem interface.
 */
export function instanceOfLinkPreviewItem(value: object): value is LinkPreviewItem {
    return true;
}

export function LinkPreviewItemFromJSON(json: any): LinkPreviewItem {
    return LinkPreviewItemFromJSONTyped(json, false);
}

export function LinkPreviewItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): LinkPreviewItem {
    if (json == null) {
        return json;
    }
    return {
        
        'rowIndex': json['rowIndex'] == null ? undefined : json['rowIndex'],
        'joinKeyValue': json['joinKeyValue'] == null ? undefined : json['joinKeyValue'],
        'matchedEntityId': json['matchedEntityId'] == null ? undefined : json['matchedEntityId'],
        'matchedEntityName': json['matchedEntityName'] == null ? undefined : json['matchedEntityName'],
        'isLinked': json['isLinked'] == null ? undefined : json['isLinked'],
    };
}

export function LinkPreviewItemToJSON(json: any): LinkPreviewItem {
    return LinkPreviewItemToJSONTyped(json, false);
}

export function LinkPreviewItemToJSONTyped(value?: LinkPreviewItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'rowIndex': value['rowIndex'],
        'joinKeyValue': value['joinKeyValue'],
        'matchedEntityId': value['matchedEntityId'],
        'matchedEntityName': value['matchedEntityName'],
        'isLinked': value['isLinked'],
    };
}

